/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Drastic_Tech_Process_Error_LogInputs */



/**
* | output |
* | --- |
* | "[DRASTIC error]: {error}" |
*
* @param {Drastic_Tech_Process_Error_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_process_error_log = /** @type {((inputs: Drastic_Tech_Process_Error_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Process_Error_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`[DRASTIC erreur] : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`[DRAMATIVER Fehler]: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`[Errore DRASTICO]: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`[КРИСТАЛЬНАЯ ошибка]: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`[Error DRÁSTICO]: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`[严重错误]: ${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`[重大なエラー]: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`[गंभीर त्रुटि]: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`[Erro DRASTIC]: ${i?.error}`)
	return /** @type {LocalizedString} */ (`[DRASTIC error]: ${i?.error}`)
});